<script setup lang="ts">
import { useBreadcrumbs } from '@/api/breadcrumbs';
import BreadCrumbTree from '@/components/BreadCrumbTree.vue';
import ContentPage from '@/components/ContentPage.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { result: breadcrumbData } = useBreadcrumbs();
</script>
<template>
  <ContentPage
    :title="t('header.items.breadcrumbEdit')"
    class="bg-gnist-gray-light-light"
  >
    <BreadCrumbTree v-if="breadcrumbData" :model-value="breadcrumbData" edit />
  </ContentPage>
</template>
